<template>
  <div>
    <div class="nav_pos">
      <span class="text">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) in breadUrl" :key="index">
          <router-link v-if="item.url" :to="item.url">{{ item.name }}</router-link>
          <a v-else>{{ item.name }}</a>
        </el-breadcrumb-item>
        <div class="searchWrap">
          <!-- <span>搜索：</span> -->
          <el-input class="searchInput" v-model="searchInput" placeholder="请输入搜索内容" @keyup.enter.native="searchDetail()">
            <i class="el-icon-search elIconSearch_cus1" slot="suffix" @click.stop="searchDetail()"></i>
          </el-input>
          <!-- <span class="text2"
            >为您找到<label class="red">369</label>条结果</span
          > -->
        </div>
      </el-breadcrumb>
    </div>
    <div class="top_line">
      <LeftTab :info="info" @switchCon="switchPage"></LeftTab>
      <div class="right_wrap">
        <el-tabs v-model="purchaseType" class="tab_wrap2 bidtab2" @tab-click="switchType">
          <el-tab-pane :label="item.Name" :name="item.Value" v-for="(item, index) in purchaseTypes" :key="index"></el-tab-pane>
        </el-tabs>
        <ul class="li_wrap list_minHeight line_li_wrap">
          <li class="clear" v-for="(item, index) in biddlist1" :key="index" @click.stop="goDetail(item.id)">
            <span class="li_left overell">{{ item.title }}</span>
            <span class="li_right">{{ item.date }}</span>
          </li>
        </ul>
        <el-pagination class="page_wrap" background :page-size="pageSize" layout="prev, pager, next" :total="quesLength" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LeftTab from '@/components/common/LeftTab'
export default {
  name: 'news',
  components: { LeftTab },
  data() {
    return {
      breadUrl: {},
      searchInput: '',
      info: {
        //左边tab的数据
        imgUrl: require('../../assets/img/icon_biddingarea.png'),
        text: '招标专区',
        egText: 'Procurement',
        tabList: []
      },
      purchaseTypes: [],
      purchaseType: 0,
      quesLength: 0,
      biddlist1: [],
      special: null,
      cateId: '',
      pageIndex: 1,
      pageSize: 11
    }
  },
  mounted() {
    sessionStorage.setItem('IndexTab', 'bidding')
    this.getRequest('/Information/Index')
      .then((res) => {
        var data = res.data
        if (data.errcode == 0) {
          this.cateId = data.special.Id
          this.special = data.special
          this.getCates()
          this.getPurchaseTypes()
          this.getList(this.cateId, this.purchaseType)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  methods: {
    getCates() {
      let config = {
        params: {
          cateId: this.special.Id
        }
      }
      this.getRequest('/Information/GetCates', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.info.tabList = data.cateList
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPurchaseTypes() {
      this.getRequest('/Information/GetPurchaseTypes')
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.purchaseTypes = data.purchaseTypes
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getList(cateId, purchaseType) {
      let config = {
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          cateId: cateId,
          purchaseType: purchaseType,
          title: this.searchInput
        }
      }
      this.getRequest('/Information/GetList', config)
        .then((res) => {
          var data = res.data
          if (data.errcode == 0) {
            this.quesLength = data.quesLength
            this.biddlist1 = data.infoList
            this.breadUrl = data.nav
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getList(this.cateId, this.purchaseType)
    },
    switchPage(id) {
      this.pageIndex = 1
      this.cateId = id
      this.searchInput = ''
      this.getList(id, this.purchaseType)
    },
    switchType(type) {
      this.pageIndex = 1
      this.purchaseType = type.name
      this.searchInput = ''
      this.getList(this.cateId, this.purchaseType)
    },
    goDetail(id) {
      let routerData = this.$router.resolve({
        name: 'detail',
        query: { id: id, cateId: this.cateId, purchaseType: this.purchaseType }
      })
      window.open(routerData.href, '_blank')
    },
    searchDetail() {
      this.pageIndex = 1
      this.getList(this.special.Id, this.purchaseType)
    }
  }
}
</script>
<style scoped lang="scss">
.nav_pos .el-breadcrumb {
  position: relative;
  display: block;
}
.searchWrap {
  display: flex;
  position: absolute;
  right: 0;
  top: -7px;
  span {
    font-weight: bold;
  }
  ::v-deep.el-input__suffix {
    top: 3px;
  }
}
.tab_wrap2 ::v-deep .el-tabs__header .el-tabs__item.is-active {
  border-bottom: 2px solid #fafafa;
}
</style>
